"use client";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import MapContainer from "@/components/maps/mapcontainer";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

export default function Page() {
  return (
    <>
      <div>
        <h1 className="text-4xl font-extrabold tracking-tight lg:text-4xl">PySpark Big Data Project</h1>

        <Tabs defaultValue="final-result" className="w-full h-[700px]">
          <TabsList>
            {/* <TabsTrigger value="synopsis">Synopsis</TabsTrigger> */}
            <TabsTrigger value="final-result">Final Results</TabsTrigger>
            <TabsTrigger value="data-preprocess">Data Pre-processing</TabsTrigger>
            <TabsTrigger value="data-analysis">Data Analysis</TabsTrigger>
          </TabsList>
          {/* <TabsContent value="synopsis">
            <div className="w-[80vw] h-[70vh]">
              <Card className="bg-card text-card-foreground shadow-md z-10 w-full flex flex-col h-[75vh]">
                <CardHeader>
                  <CardTitle>Synopsis</CardTitle>
                </CardHeader>
                <CardContent className=" flex-grow flex flex-col gap-4 pt-4 overflow-hidden h-[70vh] p-0">
                  Currently Under Construction
                </CardContent>
              </Card>
            </div>
          </TabsContent> */}
          <TabsContent value="final-result" className="w-[80vw] ">
            <MapContainer />
          </TabsContent>
          <TabsContent value="data-preprocess">
            <Card className="bg-card text-card-foreground shadow-md z-10 w-full flex flex-col h-[75vh]">
              <CardHeader>
                <CardTitle>Data Preprocesing</CardTitle>
              </CardHeader>
              <CardContent className="flex-grow flex flex-col gap-4 pt-4 overflow-hidden h-[70vh] p-0">
                <iframe src="/final-datapreprocessing.html" className="w-[80vw] h-[100%]" />
              </CardContent>
            </Card>
          </TabsContent>
          <TabsContent value="data-analysis" className="p-0">
            <Card className="bg-card text-card-foreground shadow-md z-10 w-full flex flex-col h-[75vh]">
              <CardHeader>
                <CardTitle>Main Data Analysis</CardTitle>
              </CardHeader>
              <CardContent className="flex-grow flex flex-col gap-4 pt-4 overflow-hidden h-[70vh] p-0">
                <iframe src="/final-milestone.html" className="w-[80vw] h-[100%]" />
              </CardContent>
            </Card>
          </TabsContent>
        </Tabs>
      </div>
    </>
  );
}
